const API_KEY = 'AIzaSyByZ5Skag2Sh1LkVPclh49YM4I5P77TZNg'


export async function findLatLonFromIP() {

  const res = await fetch(`https://www.googleapis.com/geolocation/v1/geolocate?key=${API_KEY}`, {
    method: 'POST',
    data: JSON.stringify({ considerIp: true }),
    contentType: 'application/json charset=utf-8',
    dataType: 'json',
  })
  const json = await res.json()

  if (json && json.location) {
    return { lat: json.location.lat, lng: json.location.lng }
  } else {
    return 'No location object in geolocate API response.'
  }
}


export async function getLocFromLatLng(lat, lng) {

  const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`, {
    method: 'GET',
    data: JSON.stringify({ considerIp: true }),
    contentType: 'application/json charset=utf-8',
    dataType: 'json',
  })
  const json = await res.json()

  let results = []

  json.results.forEach((address) => {
    address.address_components.forEach((component) => {
      if (component.types.includes('administrative_area_level_1')) {
        results['state'] = component.long_name
        results['uf'] = component.short_name
        return component.long_name
      }
      if (component.types.includes('administrative_area_level_2')) {
        results['city'] = component.long_name
        return component.long_name
      }
    })
  })

  return results
}


/**
 * @returns {Promise<{
 * uf: string,
 * success: boolean,
 * msg: string,
 * } | {}>}
 */
export async function vivazGeoloc() {
  try {
    let { lat, lng } = await findLatLonFromIP()
    let { uf } = await getLocFromLatLng(lat, lng)

    return {
      uf,
      success: true,
      msg: 'Localizado com sucesso!',
    }
  } catch (_) {
    return {
      uf: '',
      success: false,
      msg: 'Não foi possivel localizar',
    }
  }
}




// WEBPACK FOOTER //
// ./src/api/geoloc.js